<div id="authorized-header" class="flex w-full justify-between p-4 px-8">
  <div class="flex items-center">
    <app-logo [isLogin]="true"/>
    <div class="navbar-items flex-nowrap">
      @if ((isOwnerOrRentee()) && hasPermission(Permission.ViewJobs)) {
        <navigation-item [route]="'/dashboard'" [title]="'Home'">
          <svg icon class="w-4 h-4 text-gray-800 flex-shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
               fill="currentColor" viewBox="0 0 24 20">
            <path fill-rule="evenodd"
                  d="M11.3 3.3a1 1 0 0 1 1.4 0l6 6 2 2a1 1 0 0 1-1.4 1.4l-.3-.3V19a2 2 0 0 1-2 2h-3a1 1 0 0 1-1-1v-3h-2v3c0 .6-.4 1-1 1H7a2 2 0 0 1-2-2v-6.6l-.3.3a1 1 0 0 1-1.4-1.4l2-2 6-6Z"
                  clip-rule="evenodd"/>
          </svg>
        </navigation-item>
      }

      @if (isOwnerOrRentee() && hasPermission(Permission.ViewJobs)) {
        <navigation-item [route]="'/jobs'" [title]="'Jobs'">
          <svg icon class="w-4 h-4 flex-shrink-0" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 14 14">
            <path
              d="M13.66 2.73a.52.52 0 00-.36-.3.49.49 0 00-.45.14l-2 2.05a1 1 0 01-1.41 0 1 1 0 010-1.42l2-2.05a.5.5 0 00.13-.45.48.48 0 00-.3-.36 4.4 4.4 0 00-5.85 5.49.25.25 0 01-.06.26L.53 10.92a1.8 1.8 0 002.55 2.55l4.83-4.83a.27.27 0 01.26-.06A4.45 4.45 0 0012.11 8a4.42 4.42 0 001.55-5.27z"></path>
          </svg>
        </navigation-item>
      }

      @if (isOwner() && hasPermission(Permission.ViewQuotes)) {
        <navigation-item [route]="'/quotes'" [title]="'Quotes'">
          <svg icon class="w-4 h-4 flex-shrink-0" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 14 14">
            <path
              d="M14 3.75a.75.75 0 00-.22-.53l-3-3a.75.75 0 00-.53-.22h-9A1.25 1.25 0 000 1.25v11.5A1.25 1.25 0 001.25 14h11.5A1.25 1.25 0 0014 12.75zM1.75 12.5a.25.25 0 01-.25-.25V1.75a.25.25 0 01.25-.25h7.5a.25.25 0 01.25.25v2a.76.76 0 00.75.75h2a.25.25 0 01.25.25v7.5a.25.25 0 01-.25.25z"></path>
            <path
              d="M5 5.25a.76.76 0 01.63.31.75.75 0 101.24-.84 2.16 2.16 0 00-1-.79.25.25 0 01-.15-.23v-.2a.75.75 0 00-1.5 0v.24a.24.24 0 01-.11.26A2 2 0 003 5.75a1.85 1.85 0 001.11 1.69l1.19.5a.35.35 0 01.2.31.5.5 0 01-.5.5.76.76 0 01-.63-.31.75.75 0 00-1.24.84 2.16 2.16 0 001 .79.25.25 0 01.15.23v.2a.75.75 0 001.5 0v-.24a.24.24 0 01.11-.26A2 2 0 007 8.25a1.85 1.85 0 00-1.11-1.69l-1.19-.5a.35.35 0 01-.2-.31.5.5 0 01.5-.5zM10.25 9h-1.5a.75.75 0 000 1.5h1.5a.75.75 0 000-1.5z"></path>
          </svg>
        </navigation-item>
      }

      @if (isOwnerOrRentee() && hasPermission(Permission.ViewAssets)) {
        <navigation-item [route]="'/assets'" [title]="'Assets'">
          <svg icon class="w-4 h-4 flex-shrink-0" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
               viewBox="0 0 14 14">
            <circle cx="7" cy="7" r="3"></circle>
            <path
              d="M1 5a1 1 0 01-1-1V2a2 2 0 012-2h2a1 1 0 010 2H2.25a.25.25 0 00-.25.25V4a1 1 0 01-1 1zM13 5a1 1 0 01-1-1V2.25a.25.25 0 00-.25-.25H10a1 1 0 010-2h2a2 2 0 012 2v2a1 1 0 01-1 1zM4 14H2a2 2 0 01-2-2v-2a1 1 0 012 0v1.75a.25.25 0 00.25.25H4a1 1 0 010 2zM12 14h-2a1 1 0 010-2h1.75a.25.25 0 00.25-.25V10a1 1 0 012 0v2a2 2 0 01-2 2z"></path>
          </svg>
        </navigation-item>
      }

      @if (hasPermission(Permission.ViewServiceRequests) && !isOnlyRentee()) {
        <navigation-item [route]="'/service-requests'" [title]="'Service Requests'">
          <svg icon class="w-4 h-4 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 2 20 20">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M10 3v4a1 1 0 0 1-1 1H5m4 8h6m-6-4h6m4-8v16a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V7.914a1 1 0 0 1 .293-.707l3.914-3.914A1 1 0 0 1 9.914 3H18a1 1 0 0 1 1 1Z"/>
          </svg>
        </navigation-item>
      }

      @if (hasPermission(Permission.CreateServiceRequest) && !isOnlyRentee()) {
        <div id="add-service-request-container" class="flex items-center relative flex-shrink-0">
          <button id="add-service-request-btn" class="navbar-button pr-3 pl-3 relative z-10"
                  [routerLink]="['/service-request']">
            Add Service Request
          </button>
          @if (getPendingServiceRequestAssetsCount() > 0) {
            <span id="service-request-counter" (click)="toggleServiceRequestPopup()"
                  class="absolute top-[-8px] right-[-15px] bg-gray-700 text-white px-1 py-1 text-sm font-semibold rounded-full text-center z-20 cursor-pointer w-7 h-7">
              {{ getPendingServiceRequestAssetsCount() }}
            </span>
          }
        </div>
        @if (isServiceRequestPopupVisible) {
          <app-service-request-popup id="service-request-popup" (close)="closeServiceRequestPopup()"/>
        }
      }
    </div>
  </div>
  <div class="flex align-middle lg:hidden items-center">
    <div>
      <button (click)="toggleMobileMenu()" type="button" id="mobile-menu-button"
              class="relative flex items-center rounded-full align-middle justify-center font-bold">
        <svg class="w-8 h-8 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
             width="24" height="24" fill="none" viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M5 7h14M5 12h14M5 17h14"/>
        </svg>
      </button>
    </div>
    @if (isMobileMenuVisible) {
      <div id="mobile-menu-dropdown"
           class="absolute right-4 top-16 z-50 w-[200px] origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden"
           role="menu">
        <div class="border-b border-gray-300 pb-1 pt-2 w-full">
          <div class="flex align-middle items-center flex-col">
            @if (isOwnerOrRentee() && hasPermission(Permission.ViewJobs)) {
              <div [routerLink]="['/dashboard']" (click)="toggleMobileMenu()" id="mobile-menu-home"
                   class="flex items-center px-4 py-2 text-sm font-bold w-full hover:bg-gray-200 cursor-pointer">
                Home
              </div>
            }

            @if (hasPermission(Permission.ViewJobs) && isOwnerOrRentee()) {
              <div [routerLink]="['/jobs']"
                   (click)="toggleMobileMenu()" id="mobile-menu-jobs"
                   class="flex items-center px-4 py-2 text-sm font-bold w-full hover:bg-gray-200 cursor-pointer">
                Jobs
              </div>
            }

            @if (hasPermission(Permission.ViewQuotes) && isOwner()) {
              <div [routerLink]="['/quotes']"
                   (click)="toggleMobileMenu()" id="mobile-menu-quotes"
                   class="flex items-center px-4 py-2 text-sm font-bold w-full hover:bg-gray-200 cursor-pointer">
                Quotes
              </div>
            }

            @if (hasPermission(Permission.ViewAssets) && isOwnerOrRentee()) {
              <div [routerLink]="['/assets']"
                   (click)="toggleMobileMenu()" id="mobile-menu-assets"
                   class="flex items-center px-4 py-2 text-sm font-bold w-full hover:bg-gray-200 cursor-pointer">
                Assets
              </div>
            }

            @if (hasPermission(Permission.ViewServiceRequests) && !isOnlyRentee()) {
              <div [routerLink]="['/service-requests']"
                   (click)="toggleMobileMenu()"
                   id="mobile-menu-service-requests"
                   class="flex items-center px-4 py-2 text-sm font-bold w-full hover:bg-gray-200 cursor-pointer">
                Service Requests
              </div>
            }

            @if (hasPermission(Permission.CreateServiceRequest) && !isOnlyRentee()) {
              <div class="flex items-center px-4 py-2 text-sm font-bold w-full hover:bg-gray-200 cursor-pointer">
                <a [routerLink]="['/service-request']" (click)="toggleMobileMenu()" class="w-full">
                  Add Service Request
                </a>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <user-profile/>
</div>
